import { Pipe, PipeTransform } from '@angular/core';
import { ProjectTaxLocationSchema } from '@vmspdb/definitions';
import { AbstractEnumPipe } from './abstract-enum.pipe';

@Pipe({
  name: 'enumProjectTaxLocation',
  standalone: false,
})
export class EnumProjectTaxLocationPipe
  extends AbstractEnumPipe
  implements PipeTransform
{
  readonly enum = ProjectTaxLocationSchema;
}
